import { callFunction } from './callableClient'
import type { PartnerNotificationItem } from '../types/partnerNotification'

type ListResponse = {
  notifications: PartnerNotificationItem[]
}

export async function listPartnerNotifications(limit = 50): Promise<PartnerNotificationItem[]> {
  const res = await callFunction<{ limit?: number }, ListResponse>('partnerListNotifications', { limit })
  return res.notifications
}

export async function markPartnerNotificationRead(notificationId: string): Promise<void> {
  await callFunction<{ notificationId: string }, { ok: true }>('partnerMarkNotificationRead', {
    notificationId,
  })
}

export async function markAllPartnerNotificationsRead(): Promise<void> {
  await callFunction<Record<string, never>, { updatedCount: number }>(
    'partnerMarkAllNotificationsRead',
    {},
  )
}
